module.exports = __webpack_public_path__ + "static/img/19.6a907ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/19.jpg
// module id = DuRq
// module chunks = 0